import { appMutations } from "../mutation-types";

export default {
	namespaced: true,

	state: {
		dark: JSON.parse( localStorage.getItem( "app.dark" ) ),
		drawer: false
	},

	actions: {
		setDark( { commit }, val = false ) {
			commit( appMutations.SET_DARK, val );
		},

		setDrawer( { commit }, val ) {
			commit( appMutations.SET_DRAWER, val );
		},

		toggleDrawer( { commit } ) {
			commit( appMutations.TOGGLE_DRAWER );
		}
	},

	mutations: {
		[appMutations.SET_DARK]( store, val ) {
			store.dark = val;
			localStorage.setItem( "app.dark", val );
		},

		[appMutations.SET_DRAWER]( store, val ) {
			store.drawer = val;
		},

		[appMutations.TOGGLE_DRAWER]( store ) {
			store.drawer = !store.drawer;
		}
	}
};
